/**
 * French Pythagorean theorem prompts (ADR 0109 §4). A colon and a question mark
 * take a space before them, as the other French prompts write them; the key
 * says "pas" where English says "not".
 */
const CM = ` cm`;

export const pythagoreanPrompts = {
    hypotenuse: () => `Trouve l'hypoténuse.`,
    missingSide: () => `Trouve le côté manquant.`,
    rightTriangle: (a: number, b: number, c: number) =>
        `Peut-on former un triangle rectangle avec des côtés de ${a}${CM}, ${b}${CM} et ${c}${CM} ?`,
    yes: (aSquared: number, bSquared: number, cSquared: number) =>
        `Oui : ${aSquared} + ${bSquared} = ${cSquared}`,
    no: (aSquared: number, bSquared: number, sum: number, cSquared: number) =>
        `Non : ${aSquared} + ${bSquared} = ${sum}, pas ${cSquared}`,
};
